import { observable } from 'mobx'
import { CommonHistoryLogRequest } from '../../requests/CommonHistoryLogRequest'

class ListHistoryLogStore {
  @observable list = []
  @observable historyLists = []
  @observable isLoading = false
  @observable message = null

  getList = async documentCode => {
    this.isLoading = true
    this.list = [] // Reset to empty array immediately
    this.message = null

    try {
      const response = await CommonHistoryLogRequest.getList(documentCode)

      // Ensure we always have an array
      if (response && response.data) {
        if (Array.isArray(response.data)) {
          this.list = response.data
        } else {
          console.warn('Expected array but got:', typeof response.data)
          this.list = []
        }
      } else {
        this.list = []
      }

      this.message = this.list.length === 0 ? 'Không có lịch sử' : null
    } catch (error) {
      console.error('Error fetching history log:', error)
      this.list = []
      this.message = 'Có lỗi xảy ra khi tải lịch sử'
    } finally {
      this.isLoading = false
    }
  }

  getLists = async documentCode => {
    this.isLoading = true
    this.historyLists = []

    try {
      const response = await CommonHistoryLogRequest.getLists(documentCode)

      if (response && response.data) {
        if (Array.isArray(response.data)) {
          this.historyLists = response.data
        } else {
          console.warn('Expected array but got:', typeof response.data)
          this.historyLists = []
        }
      } else {
        this.historyLists = []
      }

      this.message = this.historyLists.length === 0 ? 'Không có lịch sử' : null
    } catch (error) {
      console.error('Error fetching history lists:', error)
      this.historyLists = []
      this.message = 'Có lỗi xảy ra khi tải lịch sử'
    } finally {
      this.isLoading = false
    }
  }

  clear = () => {
    this.list = []
    this.historyLists = []
    this.isLoading = false
    this.message = null
  }
}

export default new ListHistoryLogStore()
